import React, { useMemo } from "react";
import dayjs from "dayjs";

// material-ui
import { useTheme } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

// project import
import MainCard from "components/MainCard";
import { WarningFilled } from "@ant-design/icons";

const AlertBlock = ({ data }) => {
  const theme = useTheme();

  const depletionDate = useMemo(() => {
    if (!data?.remainingDays) return null;
    return dayjs().add(data.remainingDays, "day").format("YYYY-MM-DD");
  }, [data?.remainingDays]);

  if (!data || data.balance <= 0) return null;

  return (
    <MainCard
      sx={{
        bgcolor: "#FFF8E6",
        border: "1px solid #FFE58F",
        borderRadius: "8px",
        boxShadow: "none",
      }}
      contentSX={{ p: 2 }}
    >
      <Stack direction='row' spacing={1.5} alignItems='flex-start'>
        <WarningFilled
          style={{ color: "#D46B08", fontSize: "16px", marginTop: "2px" }}
        />
        <Stack spacing={0.5}>
          <Typography
            variant='subtitle2'
            sx={{
              color: "#D46B08",
              fontWeight: "bold",
              fontSize: "14px",
            }}
          >
            Critical Alert
          </Typography>
          <Typography
            variant='body2'
            sx={{
              color: "rgba(0, 0, 0, 0.65)",
              fontSize: "13px",
              lineHeight: 1.5,
            }}
          >
            Your credits are projected to be depleted by{" "}
            {depletionDate || "<Date>"}. Please procure additional credits soon
            to ensure uninterrupted network management services.
          </Typography>
        </Stack>
      </Stack>
    </MainCard>
  );
};

export default AlertBlock;
